var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoBankCards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5,7.7c-0.4-0.5-0.9-0.7-1.5-0.8L8.8,5.1C8.2,5.1,7.6,5.3,7.2,5.6C6.7,6,6.4,6.6,6.4,7.2l-0.4,4H4.3 c-1.2,0-2.3,1-2.3,2.3v13.2c0,1.2,1,2.3,2.3,2.3h21.2c1.2,0,2.3-1,2.3-2.3v-2.1l0.8,0.1c0.1,0,0.1,0,0.2,0c1.2,0,2.1-0.9,2.2-2.1 L32,9.3C32,8.7,31.9,8.1,31.5,7.7z M4.3,12.3h21.2c0.6,0,1.1,0.5,1.1,1.1v1.2H3.2v-1.2C3.2,12.8,3.7,12.3,4.3,12.3z M3.2,15.8h23.4 v2.4H3.2V15.8z M25.5,27.7H4.3c-0.6,0-1.1-0.5-1.1-1.1v-7.2h23.4v7.2C26.5,27.2,26,27.7,25.5,27.7z M30.8,9.2l-1.1,13.2 c0,0.6-0.6,1-1.2,1l-0.8-0.1v-9.9c0-1.2-1-2.3-2.3-2.3H7.1l0.4-3.9c0,0,0,0,0,0c0-0.6,0.6-1,1.2-1l21.1,1.8c0.3,0,0.5,0.2,0.7,0.4 C30.8,8.7,30.8,8.9,30.8,9.2z M24.1,21.1h-5.6c-0.3,0-0.6,0.3-0.6,0.6v3.7c0,0.3,0.3,0.6,0.6,0.6h5.6c0.3,0,0.6-0.3,0.6-0.6v-3.7 C24.7,21.4,24.4,21.1,24.1,21.1z M23.5,24.8H19v-2.5h4.5V24.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoBankCards);
export default __webpack_public_path__ + "static/media/picto-bank-cards.52d817f4.svg";
export { ForwardRef as ReactComponent };